import { messages } from '@asuene-esg/i18n/src/locales/messages'
/**
 * Constants
 */
const LOCAL_STORAGE_KEY = 'nuxt-i18n-lang'
// 設定可能な言語
const AVAILABLE_LOCALES = Object.keys(messages)

/**
 * 言語情報を保存する
 * @param locale 言語情報
 * @returns void
 */
export const saveLocale = (locale: string): void => {
  if (!AVAILABLE_LOCALES.includes(locale)) {
    return
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, locale)
}

/**
 * 言語情報を復元する
 * @returns locale 言語情報
 */
const restoreLocale = (): string | null => {
  return localStorage.getItem(LOCAL_STORAGE_KEY)
}

/**
 * ユーザーのブラウザの言語情報の一覧の中から設定可能な言語を取得する
 * @returns locale 言語情報
 */
const getDefaultLocale = (): string => {
  const browserLocales
    = navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages
  const locale = browserLocales.find((_locale) => {
    return AVAILABLE_LOCALES.includes(_locale)
  },
  )

  return locale || 'ja'
}

const getLocaleFromUrl = () => {
  const url = new URL(location.href)
  return new URLSearchParams(url.search).get('locale')
}

export const setInitialLocale = () => {
  const localeFromUrl = getLocaleFromUrl()
  if (localeFromUrl) {
    saveLocale(localeFromUrl)
    return localeFromUrl
  }
  return restoreLocale() || getDefaultLocale()
}
